import React, { useEffect, useState } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import { get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";

const LovedBy = ({ seletedGymId }) => {
  const [gymStats, setGymStats] = useState({ data: [], totalGyms: 0 });

  const getData = async (gymId) => {
    try {
      const resp = await get(
        `${endpoints.gym}/week?filter=favourite&timePeriod=week&id=${gymId}`
      );
      if (resp?.data?.success) {
        const dataList = resp?.data?.data || [];

        let barHeights = new Array(7).fill(0);
        let totalCount = 0;

        dataList.forEach((item) => {
          const date = new Date(item.date);
          let dayOfWeek = date.getDay();

          dayOfWeek = (dayOfWeek + 6) % 7;

          barHeights[dayOfWeek] = item.count;
          totalCount += item.count;
        });

        setGymStats({
          data: barHeights,
          totalGyms: totalCount,
        });
      }
    } catch (error) {
      console.error("Error fetching gym stats:", error);
    }
  };

  useEffect(() => {
    seletedGymId != "" && getData(seletedGymId);
  }, [seletedGymId]);

  return (
    <Card
      className="rounded-4 mb-2"
      style={{ height: "300px", marginBottom: 0 }}
    >
      <CardBody className="d-flex flex-column justify-content-between align-items-stretch h-100">
        <div>
          <CardTitle
            tag="h5"
            className="ff-sora font-size-16 primary-black fw-normal"
          >
            Loved By
          </CardTitle>
          <p className="light-black ff-sora font-size-14 fw-normal mb-0">
            Loved by users this week
          </p>
          <p className="primary-black ff-sora font-size-24 fw-bold mb-4">
            {gymStats.totalGyms}
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-end flex-nowrap">
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map(
            (day, index) => {
              const today = new Date().getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
              const dayIndex = (index + 1) % 7; // Adjust index to align with `getDay` (1 = Mon, ..., 0 = Sun)
              const backgroundColor =
                dayIndex === today
                  ? "rgba(59, 171, 166, 0.35)" // Alternate colors for other days
                  : "#F5F5F5"; // Alternate colors for other days

              return (
                <div
                  key={index}
                  className="text-center d-flex flex-column align-items-center"
                  style={{ width: "12%", flex: "0 0 auto" }}
                >
                  <div
                    style={{
                      width: "100%",
                      height: `${gymStats.data[index] * 5 + 20}px`,
                      backgroundColor: backgroundColor,
                      borderRadius: "12px",
                    }}
                  />
                  <p className="light-black font-size-14 fw-normal ff-sora pt-2 mb-0">
                    {day}
                  </p>
                </div>
              );
            }
          )}
        </div>
      </CardBody>
    </Card>
  );
};

export default LovedBy;
